import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/hotzb2.png'
import _imports_1 from '@/assets/images/huangguan.png'
import _imports_2 from '@/assets/images/hotzb1.png'
import _imports_3 from '@/assets/images/hotzb3.png'


const _withScopeId = n => (_pushScopeId("data-v-4268fbc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "navbar" }
const _hoisted_3 = { class: "navTitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_5 = {
  key: 0,
  class: "top3"
}
const _hoisted_6 = { class: "box" }
const _hoisted_7 = {
  class: "navtar",
  style: {"margin-top":"60px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "hot" }
const _hoisted_11 = { class: "box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "huanguan",
  src: _imports_1,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_13 = { class: "navtar" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_15 = { class: "name" }
const _hoisted_16 = { class: "hot" }
const _hoisted_17 = { class: "box" }
const _hoisted_18 = {
  class: "navtar",
  style: {"margin-top":"60px"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "hot" }
const _hoisted_22 = {
  key: 1,
  class: "list"
}
const _hoisted_23 = { class: "itembox" }
const _hoisted_24 = { class: "user" }
const _hoisted_25 = { class: "info" }
const _hoisted_26 = { class: "renqi" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_icon, {
        name: "arrow-left",
        color: "#fff",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router))),
        class: "icon"
      }),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('home.staranchor')), 1 /* TEXT */),
      _hoisted_4
    ]),
    ($setup.hotzb.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_van_image, {
                class: "vanimg1",
                round: "",
                fit: "cover",
                src: $setup.hotzb[1].portrait
              }, null, 8 /* PROPS */, ["src"]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.hotzb[1].nickname), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('home.renhot') + $setup.hotzb[1].heat), 1 /* TEXT */),
            ($setup.hotzb[1].is_follow == 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "start",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toStar($setup.hotzb[1].id)))
                }, _toDisplayString(_ctx.$t('home.onFocus')), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "onstart",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.enStart($setup.hotzb[1].id)))
                }, _toDisplayString(_ctx.$t('home.areadyfocus')), 1 /* TEXT */))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_van_image, {
                class: "vanimg2",
                round: "",
                fit: "cover",
                src: $setup.hotzb[0].portrait
              }, null, 8 /* PROPS */, ["src"]),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, _toDisplayString($setup.hotzb[0].nickname), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('home.renhot') + $setup.hotzb[0].heat), 1 /* TEXT */),
            ($setup.hotzb[0].is_follow == 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "start",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toStar($setup.hotzb[0].id)))
                }, _toDisplayString(_ctx.$t('home.onFocus')), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "onstart",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.enStart($setup.hotzb[0].id)))
                }, _toDisplayString(_ctx.$t('home.areadyfocus')), 1 /* TEXT */))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_van_image, {
                class: "vanimg3",
                round: "",
                fit: "cover",
                src: $setup.hotzb[2].portrait
              }, null, 8 /* PROPS */, ["src"]),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, _toDisplayString($setup.hotzb[2].nickname), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('home.renhot') + $setup.hotzb[2].heat), 1 /* TEXT */),
            ($setup.hotzb[2].is_follow == 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "start",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.toStar($setup.hotzb[2].id)))
                }, _toDisplayString(_ctx.$t('home.onFocus')), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "onstart",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.enStart($setup.hotzb[2].id)))
                }, _toDisplayString(_ctx.$t('home.areadyfocus')), 1 /* TEXT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.listzb.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listzb, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", null, _toDisplayString(index + 4), 1 /* TEXT */),
                _createVNode(_component_van_image, {
                  class: "avatar",
                  round: "",
                  fit: "cover",
                  src: item.portrait
                }, null, 8 /* PROPS */, ["src"]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", null, _toDisplayString(item.nickname), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('home.renhot') + item.heat), 1 /* TEXT */)
                ])
              ]),
              (item.is_follow == 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "start",
                    onClick: ($event: any) => ($setup.toStar(item.id))
                  }, _toDisplayString(_ctx.$t('home.onFocus')), 9 /* TEXT, PROPS */, _hoisted_27))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "onstart",
                    onClick: ($event: any) => ($setup.enStart(item.id))
                  }, _toDisplayString(_ctx.$t('home.areadyfocus')), 9 /* TEXT, PROPS */, _hoisted_28))
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}